/**
 * Widget presets for the DIB (Defense Industrial Base) section.
 *
 * These target the geo_performance measure backed by geo_performance_fact.
 * They're surfaced in the /exec/dib dashboard WidgetPicker AND as a
 * "Geography" category in the main /exec/dashboard WidgetPicker.
 */
import type { WidgetPreset } from './widget-presets'

export const DIB_WIDGET_PRESETS: WidgetPreset[] = [
  {
    id: 'us_state_spend_map',
    title: 'DIB Spend by State',
    description: 'Choropleth: total obligated dollars flowing to each state',
    category: 'Geography',
    measure: 'geo_performance',
    config: {
      group_by: 'state',
      metrics: ['total_obligated'],
      chart_type: 'map',
    },
    gridW: 6,
    gridH: 7,
  },
  {
    id: 'state_cd_spend_map',
    title: 'CD Spend Within State',
    description: 'Congressional district choropleth for a filtered state',
    category: 'Geography',
    measure: 'geo_performance',
    config: {
      group_by: 'congressional_district',
      metrics: ['total_obligated'],
      chart_type: 'map',
    },
    gridW: 6,
    gridH: 7,
  },
  {
    id: 'state_industry_trend',
    title: 'Industry Trends (State)',
    description: 'Year-over-year trends by PSC category within a state',
    category: 'Geography',
    measure: 'geo_performance',
    config: {
      group_by: 'fiscal_year',
      metrics: ['total_obligated'],
      series_by: 'psc_level1_code',
      chart_type: 'line',
    },
    gridW: 6,
    gridH: 5,
  },
  {
    id: 'states_by_psc_dollars',
    title: 'States Ranked by PSC Dollars',
    description: 'Horizontal bar: which states get the most in a specific PSC?',
    category: 'Geography',
    measure: 'geo_performance',
    config: {
      group_by: 'state',
      metrics: ['total_obligated'],
      chart_type: 'bar',
      sort_by: '-total_obligated',
    },
    gridW: 6,
    gridH: 6,
  },
  {
    id: 'top_pscs_for_area',
    title: 'Top PSCs for Area',
    description: 'Bar chart: top product/service categories by spend for a state or CD',
    category: 'Geography',
    measure: 'geo_performance',
    config: {
      group_by: 'psc_level1_code',
      metrics: ['total_obligated'],
      chart_type: 'bar',
      sort_by: '-total_obligated',
    },
    gridW: 6,
    gridH: 5,
  },
  {
    id: 'state_dib_revenue_trend',
    title: 'State DIB Revenue (Trend)',
    description: 'Total obligated dollars over time for a state filter',
    category: 'Geography',
    measure: 'geo_performance',
    config: {
      group_by: 'fiscal_year',
      metrics: ['total_obligated'],
      chart_type: 'line',
    },
    gridW: 6,
    gridH: 5,
  },
]
